import logger from '../../services/logger';

import React from "react";
import ADEMEActorMap from "../common/ADEMEActorMap";
import { PageTitle } from "../common/Header";
import { useLocation } from 'react-router-dom';

const CarboMap = () => {
    // Récupérer l'objet univer depuis l'état de location
    const location = useLocation();
    // Récupérer les objets product et event de location.state
    const {product, action } = location.state || {};
    logger.log("product", product); 
    logger.log("action", action); 
    return (
        <div className="white-background">
            <PageTitle title="Longue vie aux objets ! La nouvelle carte publiée par l’Ademe" />
            <ADEMEActorMap 
                className="mt-3 mb-3" 
                typeaction={action || "all"} 
                product={product || ""} 
            />
            <br/><br/>
        </div>
    );
};

export default CarboMap;